import { Button, Empty } from "antd";
import { useNavigate } from "react-router-dom";
import { PlusIcon } from "../CustomIcons";

interface EmptyProps {
  title: string;
  description: string | React.ReactNode;
  image: string;
  imageHeight?: number;
  btnText?: string;
  btnLink?: string;
  className?: string;
  h2Style?: React.CSSProperties;
  pStyle?: React.CSSProperties;
  primaryBtn?: boolean;
}

export default function EmptyCard({
  title,
  description,
  image,
  imageHeight,
  btnText,
  btnLink,
  className,
  h2Style,
  pStyle,
  primaryBtn,
}: EmptyProps) {
  const navigate = useNavigate();
  return (
    <Empty
      image={image}
      styles={{ image: { height: imageHeight } }}
      className={className ?? ""}
      description={
        <div className="empty_wrap">
          <h2 style={h2Style}>{title}</h2>
          {description && <p style={pStyle}>{description}</p>}{" "}
        </div>
      }
    >
      {btnLink && (
        <Button
          type="primary"
          onClick={() => navigate(btnLink)}
          className={primaryBtn ? "primary-btn" : "outlined-btn"}
          icon={<PlusIcon style={{ color: primaryBtn ? "#fff" : "#151718" }} />}
        >
          {btnText}
        </Button>
      )}
    </Empty>
  );
}
